<template>

    <div>

        <toolbar :title="'Feedback senden'"></toolbar>

          <v-divider></v-divider>

            <v-responsive>
                <v-card-text >

                    <v-container class="pa-0">
                        <v-layout>
                            <v-flex xs12>

                                <p class="body-1">Teilen Sie mir eventuell auftretende Probleme oder Ihre Ideen zur Software gern mit. Ich freue mich auf Ihre Nachricht.</p>

                                <v-textarea counter maxlength="250" :error="feedbackError" @keydown="feedbackError=false" box value="" v-model="feedbackText" label="Probleme oder Ideen mitteilen"></v-textarea>

                                <v-layout justify-end>
                                    <v-btn :loading="btnSubmitIsLoading" color="green white--text" class="ma-2" @click.native="clickSubmit">
                                        Nachricht senden
                                        <v-icon right class="icon-send"></v-icon>

                                    </v-btn>
                                </v-layout>

                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-card-text>

            </v-responsive>
    </div>

</template>

<script>
    export default {
        name: 'feedback',
        props: {
        },
        computed: {
        },
        watch: {

        },
        data: () => ({
            btnSubmitIsLoading: false,
            feedbackError: false,
            feedbackText: ""
        }),
        methods: {
            clickSubmit: function(){

                // Wenn nichts in der Textrea drin steht
                if ( this.feedbackText.trim() === "" ) {
                    this.$EventBus.$emit("showSnackbar", { text: 'Bitte geben Sie Ihre Nachricht ein.', status: 'warning' });
                    this.feedbackError = true;
                    return;
                }

                // Lade Animation anzeigen
                this.btnSubmitIsLoading = true;

                // POST-Submit erzeugen
                this.axios.post("https://apiv1.software-schiek.de/feedback", {
                    system: "mwst-rechner",
                    betreff: "Feedback von MwSt.-Rechner",
                    text: this.feedbackText
                })
                    .then((response) => {
                        if ( response.status === 200 && response.data.status === "success" ) {
                            this._feedbackSetSuccess();
                            this.feedbackText = "";
                            //this.$router.push("/");
                        }
                        else {
                            this._feedbackSetFail();
                        }
                    })
                    .catch(() => {
                        this._feedbackSetFail();
                    });

            },
            _feedbackSetFail: function() {
                this.$EventBus.$emit("showSnackbar", { text: 'Fehler eim Senden.', status: 'error' });
                this.btnSubmitIsLoading = false;
            },
            _feedbackSetSuccess: function() {
                this.$EventBus.$emit("showSnackbar", { text: 'Nachricht gesendet.', status: 'success' });
                this.btnSubmitIsLoading = false;
            }
        }
    }
</script>

<style scoped>

</style>
